export const SortNewsByPublishedYear = (arrayOfNewsItems) => {
  const sortedNewsItems = arrayOfNewsItems
    .map((article) => {
      let publishDate
      //json parsing differences makes up for the different tracks .. not pretty
      if (article.OriginalPublishDate_s) {
        if (article.OriginalPublishDate_s.includes("-")) {
          let [day, month, year, hour, minute] = article.OriginalPublishDate_s.split(/[\s:-]/)
          publishDate = new Date(year, month - 1, day, hour, minute)
        }
        if (article.OriginalPublishDate_s.includes("/")) {
          let [day, month, year, hour, minute] = article.OriginalPublishDate_s.split(/[\s:/]/)
          publishDate = new Date(year, month - 1, day, hour, minute)
        }

        return {
          ...article,
          publishDate,
        }
      }

      if (article.originalPublishDate_s) {
        if (article.originalPublishDate_s.includes("-")) {
          let [day, month, year, hour, minute] = article.originalPublishDate_s.split(/[\s:-]/)
          publishDate = new Date(year, month - 1, day, hour, minute)
        }
        if (article.originalPublishDate_s.includes("/")) {
          let [day, month, year, hour, minute] = article.originalPublishDate_s.split(/[\s:/]/)
          publishDate = new Date(year, month - 1, day, hour, minute)
        }

        return {
          ...article,
          publishDate,
        }
      }
    })
    .sort((a, b) => b.publishDate - a.publishDate)

  return sortedNewsItems
}
